// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE:http://jsfiddle.net/dirtyharry/dw51cgu6/*/
.show-active > .notify {
    border: 3px solid #999;
    -webkit-border-radius: 30px;
    height: 18px;
    width: 18px;
    z-index:9999;
    position: absolute;
    -webkit-animation: pulsate 1s ease-out;
    -webkit-animation-iteration-count: infinite;
    opacity: 0.0
}
@-webkit-keyframes pulsate {
    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
}
`, "",{"version":3,"sources":["webpack://./src/components/BCMSRegistry/styles.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,2CAA2C;IAC3C;AACJ;AACA;IACI,IAAI,kCAAkC,EAAE,YAAY,CAAC;IACrD,KAAK,YAAY,CAAC;IAClB,MAAM,kCAAkC,EAAE,YAAY,CAAC;AAC3D","sourcesContent":["/* NOTE:http://jsfiddle.net/dirtyharry/dw51cgu6/*/\n.show-active > .notify {\n    border: 3px solid #999;\n    -webkit-border-radius: 30px;\n    height: 18px;\n    width: 18px;\n    z-index:9999;\n    position: absolute;\n    -webkit-animation: pulsate 1s ease-out;\n    -webkit-animation-iteration-count: infinite;\n    opacity: 0.0\n}\n@-webkit-keyframes pulsate {\n    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\n    50% {opacity: 1.0;}\n    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
